import { render, staticRenderFns } from "./ImportStaff.vue?vue&type=template&id=06b12633&scoped=true&"
import script from "./ImportStaff.vue?vue&type=script&lang=js&"
export * from "./ImportStaff.vue?vue&type=script&lang=js&"
import style0 from "./ImportStaff.vue?vue&type=style&index=0&id=06b12633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b12633",
  null
  
)

export default component.exports